;(function ($) {
"use strict";
    $('.wp-block-mat-banner').on('keypress click', '.menu-button', function (ev) {

        ev.preventDefault();
        $('.wp-block-mat-banner-banner-block-menu').toggle();

    })
})(jQuery);
